import Cookie from './lib/cookie';
import MemoryAdapter from './lib/adapters/memory';
import LocalStorageAdapter from './lib/adapters/local-storage';

export { MemoryAdapter, LocalStorageAdapter, Cookie };

export default Cookie;
